import {
    MIXPANEL_EVENT_PROPERTIES,
    UserStore,
    BriefStore,
    ReferrerStore,
    PagePathStore,
    SimpleStore,
} from '../../../../shared/mixpanel';
import { createProjectIdStore } from '../../../../shared/mixpanel/stores/projectId';
import { createSellerIdStore } from '../../../../shared/mixpanel/stores/sellerId';
import { createVariationIdStore } from '../../../../shared/mixpanel/stores/variationId';

const {
    NUMBER_OF_VARIATIONS,
    EDITED,
    PACKAGE,
    NAVIGATION_SOURCE,
    OFFER_DISPLAYED,
    SELLER_CARD_DISPLAYED,
    NUMBER_OF_SELECTED_PROJECTS,
    SELECTED_PROJECTS,
    USER_ACTIVATED,
} = MIXPANEL_EVENT_PROPERTIES;

export default {
    user: new UserStore(),
    brief: new BriefStore({ disableErrorLogging: true }),
    referrer: new ReferrerStore(),
    pagePath: new PagePathStore(),
    userActivated: new SimpleStore<typeof USER_ACTIVATED, boolean>(
        USER_ACTIVATED
    ),
    sellerId: createSellerIdStore(),
    projectId: createProjectIdStore(),
    variationId: createVariationIdStore({ disableErrorLogging: true }),
    numberOfVariations: new SimpleStore<typeof NUMBER_OF_VARIATIONS, number>(
        NUMBER_OF_VARIATIONS,
        {
            disableErrorLogging: true,
        }
    ),
    edited: new SimpleStore<typeof EDITED, boolean>(EDITED),
    package: new SimpleStore<typeof PACKAGE, string>(PACKAGE),
    navigationSource: new SimpleStore<typeof NAVIGATION_SOURCE, string>(
        NAVIGATION_SOURCE
    ),
    offerDisplayed: new SimpleStore<typeof OFFER_DISPLAYED, boolean>(
        OFFER_DISPLAYED
    ),
    sellerCardDisplayed: new SimpleStore<typeof SELLER_CARD_DISPLAYED, boolean>(
        SELLER_CARD_DISPLAYED
    ),
    numberOfSelectedProjects: new SimpleStore<
        typeof NUMBER_OF_SELECTED_PROJECTS,
        number
    >(NUMBER_OF_SELECTED_PROJECTS),
    selectedProjects: new SimpleStore<typeof SELECTED_PROJECTS, string[]>(
        SELECTED_PROJECTS
    ),
};
